<template>
    <!-- Main Sidebar -->
    <a-layout-sider collapsible
                    class="sider-primary"
                    breakpoint="lg"
                    collapsed-width="0"
                    width="250px"
                    :collapsed="sidebarCollapsed"
                    @collapse="$emit('toggleSidebar', !sidebarCollapsed)"
                    :trigger="null"
                    :class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme]"
                    theme="light"
                    :style="{ backgroundColor: 'transparent'}"
    >

        <div class="brand">
            <img src="../../assets/logo.png">
            <span>Order Manager</span>
        </div>
        <hr>

        <!-- Sidebar Navigation Menu for large screen -->
        <a-menu theme="light"
                mode="inline"
        >
            <a-menu-item>
                <router-link to="/">
                    <span class="icon">
						<a-icon type="dashboard" theme="filled" class="m-0" />
					</span>
					<span class="label">Dashboard</span>
				</router-link>
            </a-menu-item>

            <a-menu-item>
                <router-link to="/statistics">
                    <span class="icon">
						<a-icon type="dashboard" theme="filled" class="m-0" />
					</span>
					<span class="label">Statistic</span>
				</router-link>
            </a-menu-item>

            <!-- <a-menu-item>
                <router-link to="/pos">
                    <span class="icon">
						<a-icon type="shopping-cart" theme="filled" class="m-0" />
					</span>
					<span class="label">POS</span>
				</router-link>
            </a-menu-item> -->

            <a-menu-item>
                <router-link to="/times">
                    <span class="icon">
						<a-icon type="clock-circle" theme="filled" class="m-0" />
					</span>
					<span class="label">Time Manager</span>
				</router-link>
            </a-menu-item>

            <a-menu-item>
                <router-link to="/productstatus">
                    <span class="icon">
                        <a-icon type="down-square" theme="filled" class="m-0"/>
					</span>
					<span class="label">Product Status</span>
				</router-link>
            </a-menu-item>

            <a-sub-menu style="padding: 0;">
                <span slot="title">
                    <span class="icon">
                        <a-icon type="shop" class="m-0" />
                        
                    </span>
                    <span class="label">My Restaurant</span>
                </span>
                <a-menu-item-group>
                    <a-menu-item>
                        <router-link to="/products">
					        <span class="label">Products</span>
				        </router-link>
                    </a-menu-item>

                    <a-menu-item>
                        <router-link to="/categories">
					        <span class="label">Categories</span>
				        </router-link>
                    </a-menu-item>

                    <a-menu-item>
                        <router-link to="/menus">
					        <span class="label">Menus</span>
				        </router-link>
                    </a-menu-item>

                    <a-menu-item>
                        <router-link to="/openinghours">
					        <span class="label">Opening Hours</span>
				        </router-link>
                    </a-menu-item>

                    <a-menu-item>
                        <router-link to="/profile">
					        <span class="label">Profile</span>
				        </router-link>
                    </a-menu-item>

                    <a-menu-item>
                        <router-link to="/orders">
					        <span class="label">Orders</span>
				        </router-link>
                    </a-menu-item>
                </a-menu-item-group>
            </a-sub-menu>
        </a-menu>
        <!-- / Sidebar Navigation Menu for large screen -->

        

        <!-- Sidebar Footer -->
        <!-- <div class="aside-footer">
            <div class="footer-box">

            </div>
        </div> -->
        <!-- / Sidebar Footer -->

    </a-layout-sider>
    <!-- / Main Sidebar -->
</template>

<script>
export default {
    props : {
        // Sidebar collapsed status.
		sidebarCollapsed: {
			type: Boolean,
			default: false,
		},
			
		// Main sidebar color.
		sidebarColor: {
			type: String,
			default: "primary",
		},
			
		// Main sidebar theme : light, white, dark.
		sidebarTheme: {
			type: String,
			default: "light",
		},
    },

    data() {
        return {
            collapseNav : 0,
            
            openKeys : null
        }
    },

    methods : {
        onOpenChange(openKeys) {
			this.openKeys = this.openKeys ? this.openKeys : this.$route.meta.sidebarMap ;
				
			const latestOpenKey = openKeys.find( key => this.openKeys.indexOf( key ) === -1) ;

			if ( this.rootSubmenuKeys.indexOf( latestOpenKey ) === -1 ){
				this.openKeys = openKeys;
			}
			else{
				this.openKeys = latestOpenKey ? [ latestOpenKey ] : [] ;
			}
		},

    }

}
</script>